import React, { useState } from 'react';

import {
  closeContainer,
  errorPopupContent,
  liNetworkErrorList,
  popupSubTitle,
  popupTitle,
  uiNetworkErrorList
} from './styles';
import { mixpanelObject } from '../../../../utils/analytics/mixpanel/mixpanel';
import {
  MIXPANEL_CLOSE,
  MIXPANEL_DEBUG_STEP,
  MIXPANEL_ELEMENT,
  MIXPANEL_NETWORK_POPUP,
  MIXPANEL_POP_UP_GROUP,
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_Retry
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';
import {
  ctaEvent,
  popupCTAEvent
} from '../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../../../utils/analytics/mixpanel/mixpanelHelper';
import Portal from '../../../portal/Portal';
import { userOnboarPopupLaunchEvent } from '../../../userOnboard/MixpanelHelper';

type NetworkRetryPopupProps = {
  playerRef: any;
  popupProps: any;
};

const selfErrorMixpanel = (errorCode: string, errorMessage: string) => {
  const eventPayload = {
    errorCode: errorCode,
    errorMessage: errorMessage
  };
  if (window && window.analyticsManager) {
    window.analyticsManager.reportEvent('Playback Error', eventPayload);
  }
};

const NetworkRetryPopup = ({
  playerRef,
  popupProps
}: NetworkRetryPopupProps) => {
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const { messages = {} } = window.translationsAndConfigs;
  const errorDisplayMessage =
    messages.Player_Tech_Error ||
    'Sorry, we cannot play this video at the moment. Please try after some time.';
  const errorCodeMessage = messages.Error_Code_Message || '[Web]';
  const errorCodeText = messages.Error_Code_Text || 'Error code:';
  let errorDisplayCode = '';
  if (popupProps.playerErrorCode) {
    errorDisplayCode = errorCodeMessage.concat(' ', popupProps.playerErrorCode);
  }
  const tap_to_know =
    messages.Tap_To_Know || 'Tap to know how to check network';
  const retry = messages.Retry || 'Retry';
  selfErrorMixpanel(popupProps.playerErrorCode, errorDisplayMessage);

  const retryNetwork = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    const { playerConfig = {} } = playerRef || {};
    if (window.navigator) {
      if (window.navigator && window.navigator.onLine) {
        clearCtaEventsProperty(mixpanelObject);
        mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_Retry;
        ctaEvent();
        window.location.reload();
      }
    }
    return;
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_CLOSE;
    mixpanelObject[MIXPANEL_POP_UP_NAME] = MIXPANEL_NETWORK_POPUP;
    mixpanelObject[MIXPANEL_POP_UP_GROUP] = MIXPANEL_DEBUG_STEP;
    popupCTAEvent();
  };

  const triggerErrorPopup = () => {
    setShowErrorPopup(true);
  };

  const createErrorPopup = () => {
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_POP_UP_NAME] = MIXPANEL_NETWORK_POPUP;
    mixpanelObject[MIXPANEL_POP_UP_GROUP] = MIXPANEL_DEBUG_STEP;
    userOnboarPopupLaunchEvent();
    const { messages = {} } = window.translationsAndConfigs || {};
    const bodyContainer = document.getElementById('video-tag');
    const checkErrorPopupContainer = document.getElementsByClassName(
      'player-error-popup-container'
    )[0];
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (bodyContainer && !checkErrorPopupContainer) {
      let Network_Via_Modile_Data = messages.Network_Via_Modile_Data || '';
      let Network_Router_Message_List =
        messages.Network_Router_Message_List || '';
      let Network_Mobile_Message_List =
        messages.Network_Mobile_Message_List || '';
      let Network_HotSpot_Message_List =
        messages.Network_HotSpot_Message_List || '';
      const Network_Casting_Message_List =
        messages.Network_Casting_Message_List || '';
      if (!isMobile) {
        Network_Via_Modile_Data = messages.Network_Via_Internet_cable;
        Network_Router_Message_List =
          messages.Network_Wifi_Message_List_Desktop;
        Network_Mobile_Message_List =
          messages.Network_Internet_Message_List_Desktop;
        Network_HotSpot_Message_List =
          messages.Network_HotSpot_Message_List_Desktop;
      }
      return (
        <Portal onClick={closeErrorPopup} show={showErrorPopup}>
          <div className="player-error-popup-container">
            <div className="error-popup-content" css={errorPopupContent}>
              <span
                className="close"
                css={closeContainer}
                onClick={() => closeErrorPopup()}></span>
              <div className="popupTitle" css={popupTitle}>
                {messages.Check_Network}
              </div>
              <div className="popupSubTitle" css={popupSubTitle}>
                {messages.Network_Via_Wifi}
              </div>
              <ul className="uiNetworkErrorList" css={uiNetworkErrorList}>
                {Network_Router_Message_List.map(
                  (message: string, index: number) => {
                    return (
                      <li
                        className="liNetworkErrorList"
                        key={index}
                        css={liNetworkErrorList}>
                        {message}
                      </li>
                    );
                  }
                )}
              </ul>
              <div className="popupSubTitle" css={popupSubTitle}>
                {Network_Via_Modile_Data}
              </div>
              <ul className="uiNetworkErrorList" css={uiNetworkErrorList}>
                {Network_Mobile_Message_List.map(
                  (message: string, index: number) => {
                    return (
                      <li
                        className="liNetworkErrorList"
                        key={index}
                        css={liNetworkErrorList}>
                        {message}
                      </li>
                    );
                  }
                )}
              </ul>
              <div className="popupSubTitle" css={popupSubTitle}>
                {messages.Network_via_Hotspot}
              </div>
              <ul className="uiNetworkErrorList" css={uiNetworkErrorList}>
                {Network_HotSpot_Message_List.map(
                  (message: string, index: number) => {
                    return (
                      <li
                        className="liNetworkErrorList"
                        key={index}
                        css={liNetworkErrorList}>
                        {message}
                      </li>
                    );
                  }
                )}
              </ul>
              <div className="popupSubTitle" css={popupSubTitle}>
                {messages.Network_via_Casting_airplay}
              </div>
              <ul className="uiNetworkErrorList" css={uiNetworkErrorList}>
                {Network_Casting_Message_List.map(
                  (message: string, index: number) => {
                    return (
                      <li
                        className="liNetworkErrorList"
                        key={index}
                        css={liNetworkErrorList}>
                        {message}
                      </li>
                    );
                  }
                )}
              </ul>
            </div>
          </div>
        </Portal>
      );
    }
  };
  return (
    <>
      <div className="adult-content-error-msg">
        <div className="multi-color-border"></div>
        <div className="adult-content-error-text">{errorDisplayMessage}</div>
        <button
          id="retry-btn-id"
          className="retry-btn"
          onClick={(e) => retryNetwork(e)}>
          {retry}
        </button>
        <div className="network-code-wrapper">
          <span className="icon"></span>
          <div
            id="networkCode"
            className="network-code"
            onClick={() => triggerErrorPopup()}>
            {tap_to_know}
          </div>
        </div>
      </div>
      <div className="error-code">
        {errorCodeText} {errorDisplayCode}
      </div>
      {showErrorPopup && createErrorPopup()}
    </>
  );
};

export default NetworkRetryPopup;
